import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
	private activeDropdownId: string = null;

	@Input() public dropdownId: string;
	@Input() public dataSet: Object[];
	@Input() public isGrouped: boolean = false;
	@Input() public selectedItem: any;
	@Input() public prompt: string = '';
	@Output() public onSelectionChange: EventEmitter<Object> = new EventEmitter<Object>();

	public select(selectedItem: any): void {
		this.selectedItem = selectedItem;
		this.onSelectionChange.emit(selectedItem);
	}

	/*************************************************************************
	 * @description
	 * Open the dropdown filters on a click. When clicked on the same for the
	 * subsequnt time, close them. When clicked on anywhere else on the
	 * document, close the filters.
	 *
	 * @ param {event} Event
	 ************************************************************************/
	@HostListener('document:click', ['$event'])
	public toggleDropdown(event): void {
		if (event && event.target && event.target.parentNode) {
			const filterVal =
				event.target.getAttribute('data-dropdown-id') ||
				(event.target.parentNode.getAttribute && event.target.parentNode.getAttribute('data-dropdown-id'));

			if (filterVal) {
				if (this.activeDropdownId === filterVal) {
					this.activeDropdownId = null;
				} else {
					this.activeDropdownId = filterVal;
				}
			} else {
				this.activeDropdownId = null;
			}
		}
	}

	public isActiveDropdown(): boolean {
		return this.activeDropdownId === this.dropdownId;
	}
}
